import { gridTypes } from '../commons/constants';
import type { RunnerOptions } from '../runOptions';
import type { AndroidApp, iOSApp } from 'clickim/src/background/mobile/types';
import type { RawMobileAppVersion } from 'services/src/commons/mongo/models/mobileAppVersion';

export const isAppFromDevice = (nativeApp?: RawMobileAppVersion | iOSApp | AndroidApp): nativeApp is iOSApp | AndroidApp => {
    if (!nativeApp || 'fileName' in nativeApp) {
        return false;
    }
    return true;
};

export const shouldBlockVirtualIosBuild = (nativeApp?: RawMobileAppVersion | iOSApp | AndroidApp, gridType?: string): nativeApp is RawMobileAppVersion => {
    if (gridType === gridTypes.TESTIM_TVC) {
        return false;
    }

    if (nativeApp) {
        if (nativeApp.appMetadata && 'iOSSupportedTargetDevice' in nativeApp.appMetadata) {
            return nativeApp.appMetadata.iOSSupportedTargetDevice === 'virtual';
        }

        if ('fileName' in nativeApp) {
            return nativeApp.fileName!.endsWith('.app');
        }
    }
    return false;
};

//works only if projectData is loaded
export const isMobileProject = (options: RunnerOptions) => options.projectData?.type === 'ios' || options.projectData?.type === 'android';

export const isTestimVirtualGrid = (gridType?: string) => gridType === gridTypes.TESTIM_TVC;

export const isAppFromDeviceDisabled = (featureFlagsService: typeof import('../commons/featureFlagsService').featureFlagsService, gridType?: string) =>
    isTestimVirtualGrid(gridType) || !featureFlagsService.flags.allowAppFromDeviceRuns.isEnabled();
